import { usePage } from "@inertiajs/react";
import { ResponseBase } from "@/API/ResponseBase";

export const useUser = () => {
  const {
    props: {
      auth: { user },
    },
  } = usePage<ResponseBase>();

  return user;
};
